import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { __rest } from "tslib";
import React from 'react';
import Dropdown from '../Dropdown/Dropdown';
var DropdownMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownMenu, _React$Component);
  var _super = _createSuper(DropdownMenu);
  function DropdownMenu(props) {
    var _this;
    _classCallCheck(this, DropdownMenu);
    _this = _super.call(this, props);
    _this.toggleDropdown = function (event) {
      var opened = _this.state.opened;
      event.preventDefault();
      _this.setState({
        opened: !opened
      }, function () {
        _this.props.onClick({
          opened: !opened
        });
      });
    };
    _this.handleClickOutside = function () {
      if (_this.state.opened) {
        _this.setState({
          opened: false
        }, function () {
          _this.props.onClick({
            opened: false
          });
        });
      }
    };
    _this.state = {
      opened: props.opened
    };
    return _this;
  }
  _createClass(DropdownMenu, [{
    key: "render",
    value: function render() {
      var actionable = /*#__PURE__*/React.cloneElement(this.props.actionable, {
        onClick: this.toggleDropdown
      });
      var _a = this.props,
        opened = _a.opened,
        onClick = _a.onClick,
        props = __rest(_a, ["opened", "onClick"]);
      return /*#__PURE__*/React.createElement(Dropdown, Object.assign({}, props, {
        actionable: actionable,
        onClickOutside: this.handleClickOutside,
        opened: this.state.opened
      }));
    }
  }]);
  return DropdownMenu;
}(React.Component);
DropdownMenu.defaultProps = {
  opened: false,
  'data-aut-id': '',
  onClick: function onClick() {}
};
export default DropdownMenu;